import Make from './make'

const make = Make('support/')

interface UpdatePassword {
  password: string
}

export const updatePassword = async (
  data: UpdatePassword,
): Promise<boolean> => {
  const req = await make.put({
    endpoint: 'update-password',
    data,
    options: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

interface RequestFeature {
  page: string
  message: string
}

export const requestFeature = async (
  data: RequestFeature,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'request-feature',
    data,
    options: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}
